import { SaveFormActionHandlerService } from './save.service';
import { FormDataService } from '../data.service';
import { FormShareService } from '../share.service';
import { FormStatusService } from '../status.service';
import { SwalService } from '../../../fastlane-common/services/swal.service';
import { UserContextService } from '../../../user/services/user-context.service';
import { EmailService } from '../../../email/services/email.service';
import { PublishSubscribeService } from '../../../fastlane-common/services/publish-subscribe.service';
import { incentiveProgram } from '../../../project/project.constants';
import { AttachmentsService } from '../../../project/services/attachments.service';
import { NavService } from '../../../fastlane-common/services/nav.service';
import * as i0 from "@angular/core";
import * as i1 from "../../../project/services/attachments.service";
import * as i2 from "../data.service";
import * as i3 from "../share.service";
import * as i4 from "../status.service";
import * as i5 from "../../../fastlane-common/services/swal.service";
import * as i6 from "../../../user/services/user-context.service";
import * as i7 from "../../../email/services/email.service";
import * as i8 from "../../../fastlane-common/services/publish-subscribe.service";
import * as i9 from "../../../fastlane-common/services/nav.service";
export class AddENTIdActionHandlerService extends SaveFormActionHandlerService {
    constructor(attachmentService, formDataService, formShareService, formStatusService, swalService, userContextService, emailService, pubSubService, navService) {
        super(attachmentService, formDataService, formShareService, formStatusService, swalService, userContextService, pubSubService, emailService, navService);
        this.attachmentService = attachmentService;
        this.formDataService = formDataService;
        this.formShareService = formShareService;
        this.formStatusService = formStatusService;
        this.swalService = swalService;
        this.userContextService = userContextService;
        this.emailService = emailService;
        this.pubSubService = pubSubService;
        this.navService = navService;
    }
    exec() {
        const that = this;
        return new Promise((resolve, reject) => {
            const swalOptions = {};
            if (that.formShareService.currentIncentiveProgram ===
                incentiveProgram.film.code) {
                swalOptions.inputValue =
                    that.formShareService.filmProject.projectInfo['filmId'];
                swalOptions.title = 'Please assign a Film ID';
                swalOptions.type = 'success';
                swalOptions.inputPlaceholder = 'Please enter the FILM Id';
                swalOptions.confirmButtonText = 'Assign FILM Id';
                that.swalService
                    .textarea(swalOptions, 'required', 'Please assign the Id')
                    .then(id => {
                    that.formShareService.filmProject.projectInfo['filmId'] = id;
                    super.exec();
                })
                    .catch(() => { });
            }
            if (that.formShareService.currentIncentiveProgram ===
                incentiveProgram.dm.code) {
                swalOptions.inputValue =
                    that.formShareService.digitalProject.projectInfo['digitalId'];
                swalOptions.title = 'Please assign a DM ID';
                swalOptions.type = 'success';
                swalOptions.inputPlaceholder = 'Please enter the DM Id';
                swalOptions.confirmButtonText = 'Assign DM Id';
                that.swalService
                    .textarea(swalOptions, 'required', 'Please assign the Id')
                    .then(id => {
                    that.formShareService.digitalProject.projectInfo['digitalId'] = id;
                    super.exec();
                })
                    .catch(() => { });
            }
        });
    }
}
AddENTIdActionHandlerService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AddENTIdActionHandlerService_Factory() { return new AddENTIdActionHandlerService(i0.ɵɵinject(i1.AttachmentsService), i0.ɵɵinject(i2.FormDataService), i0.ɵɵinject(i3.FormShareService), i0.ɵɵinject(i4.FormStatusService), i0.ɵɵinject(i5.SwalService), i0.ɵɵinject(i6.UserContextService), i0.ɵɵinject(i7.EmailService), i0.ɵɵinject(i8.PublishSubscribeService), i0.ɵɵinject(i9.NavService)); }, token: AddENTIdActionHandlerService, providedIn: "root" });
